// extracted by mini-css-extract-plugin
export default {"container":"releasenotes_container__LaJGf","modal":"releasenotes_modal__1cEhO","releaseNoteContainer":"releasenotes_releaseNoteContainer__GQyLA"};